import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Option } from '@com-delta-omnichannel/mach';
import { Dropdown, DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import { BookWidgetFieldInfoModal } from '../../../../models/book-widget-aem.interfaces';
import {
  InfoTooltipMachCoreComponent,
  LimitedTooltipOptions
} from '../info-tooltip-mach-core/info-tooltip-mach-core.component';
import {
  generateRandomIdString,
  mapOptionsToDropdownItem
} from '../mach-core-utils';

@Component({
  standalone: true,
  selector: 'idp-select-mach-core',
  templateUrl: './select-mach-core.component.html',
  styleUrls: ['./select-mach-core.component.scss'],
  imports: [NgTemplateOutlet, NgClass, InfoTooltipMachCoreComponent]
})
export class SelectMachCoreComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  private dropdown!: Dropdown;
  protected selectElementId = '';

  @Input() dropdownOptions: Option[] = [];
  @Input() infoModalContent!: BookWidgetFieldInfoModal;
  @Input() infoTooltipOptions!: LimitedTooltipOptions;
  @Input() isVariableWidthDropdown = false;
  @Input() hasInfoTooltip = false;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() title = '';
  @Input() icon = '';
  @Input() showValueWhenSelected = false;
  @Input() hideDropdownListIcon = false;
  @Input() isTitleHidden = false;
  @Output() selectionChange = new EventEmitter<DropdownItem>();

  ngOnInit() {
    this.selectElementId = this.createElementId();
  }

  ngAfterViewInit() {
    this.initializeSelectDropdown();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.dropdown && changes['dropdownOptions']) {
      this.dropdown.updateOptions(
        mapOptionsToDropdownItem(this.dropdownOptions, this.icon)
      );
      let selectedIndex = this.dropdownOptions.findIndex(
        ({ selected }) => selected
      );
      if (selectedIndex === -1) {
        selectedIndex = 0;
      }
      this.dropdown.selectByIndex(selectedIndex);
    }
  }

  protected initializeSelectDropdown() {
    this.dropdown = new Dropdown({
      placeholder: this.placeholder,
      id: this.selectElementId,
      title: this.title,
      isTitleHidden: this.isTitleHidden,
      items: mapOptionsToDropdownItem(this.dropdownOptions, this.icon),
      showValueWhenSelected: this.showValueWhenSelected,
      isDisabled: this.disabled
    });

    this.dropdown.onChange(() => {
      const selectedItem = this.dropdown.getSelectedValue();
      selectedItem && this.selectionChange.emit(selectedItem);
    });
  }

  private createElementId() {
    return `select-${generateRandomIdString()}`;
  }

  ngOnDestroy(): void {
    if (this.dropdown) {
      this.dropdown.destroy();
    }
  }
}
